<template>
  <DashboardTemplate :navMenu="true">
    <div class="text-left pd-b-5">
      <h3 class="mg-y-less text-font-24">
        ข้อมูลหลักสูตร {{ getPrefixLabel(prefix) }}{{ nameTh }} {{ lastNameTh }}
      </h3>
      <p class="text-font-14">
        <span class="text-weight-bold">หลักสูตร </span
        ><span class="color-gray">{{ course.name }}</span>
      </p>
    </div>
    
    <div v-loading="loading">
      <ActivitySubjectDetailList
        :showAction="false"
        edit="false"
        :courseScoreList="courseScoreList"
        :courseId="courseId"
        :userId="userId"
        :subjectSuccess="course.subject.length == course.subjectNumber"
      />
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import ActivitySubjectDetailList from "@/components/activity/ActivitySubjectDetailList";
import { HTTP } from "@/service/axios.js";

export default {
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    prefixList() {
      return this.$store.state.prefixList;
    },
    courseList() {
      return this.$store.state.courseList;
    },
  },
  components: {
    DashboardTemplate,
    ActivitySubjectDetailList,
  },
  data() {
    return {
      activeName: "1",
      courseId: "",
      userId: "",
      loading: true,
      prefix: "",
      nameTh: "",
      lastNameTh:'',
      courseScoreList: null,
      course: ""
    };
  },
  mounted() {
    this.setParams();
    this.fetchCourseList();
    this.fetchStudentsById();
    this.fetchPercentSubjects();
  },
  methods: {
    setParams() {
      if (this.routeParams != null) {
        if (typeof this.routeParams.courseId != "undefined") {
          this.courseId = this.routeParams.courseId;
          this.userId = this.routeParams.userId;
        }
      }
    },
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
      let filter = this.courseList.filter(
        (filter) => filter._id == this.courseId
      );

      if (filter.length > 0) {
        this.course = filter[0];
      }
    },
    fetchPercentSubjects() {
      let obj = {
        courseId: this.courseId,
        userId: this.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`percent/subjects`, obj)
        .then((res) => {
   
          if (res.data.success) {
            this.courseScoreList = res.data.obj;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchManagePoint error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    fetchStudentsById() {
      let obj = {
        _id: this.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/student`, obj)
        .then((res) => {
          if (res.data.success) {
            this.prefix = res.data.obj.titleName;
            this.nameTh = res.data.obj.nameTH;
            this.lastNameTh = res.data.obj.surnameTH;
          }
        })
        .catch((e) => {
          console.log("fetchStudentsById error", e);
        });
    },
    getPrefixLabel(id) {
      let filter = this.prefixList.filter((filter) => filter.id == id);
      if (filter.length > 0) {
        return filter[0].label;
      }
    },
  },
};
</script>
